import React, { useEffect, useState } from "react";
import "./PaginaProduto.css";
import "./Pagina.css";
import { useParams, Link } from "react-router-dom";
import ModalCarrinho from "../../utils/ModalCarrinho.js";
import useLivroAcademico from "../../../hooks/useLivroAcademico.js";
import AdicionarAoCarrinhoBtn from "../AdicionarAoCarrinhoBtn.js";
import TextoTruncado from "../../utils/TruncarTexto";
import PriceCardToggle from "./PriceCardToggle";
import ModalPreview from "./ModalPreview";
const LivroAcademico = () => {
  const { id } = useParams();
  const { ebook } = useLivroAcademico(id);
  const [opcaoSelecionada, setOpcaoSelecionada] = useState("ebook");

  const precoFisico = ebook?.precoImpresso ? parseFloat(ebook.precoImpresso) : 0;
  const precoDigital = ebook?.preco ? parseFloat(ebook.preco) : 0;

  const fakeBookData = {
    ISBN: "9788544253994",
    NumeroPaginas: 320,
    Edição: "1ª",
    Formato: "16x23 (160x230mm)",
    Acabamento: "Brochura c/ orelha",
    Coloração: "Colorido",
    TipoDePapel: "Papel comum",
    Idioma: "Português",
  }

  const shareLinks = [
    {
      platform: "WhatsApp",
      iconClass: "bi-whatsapp",
      link: `https://api.whatsapp.com/send?text=${encodeURIComponent(
        window.location.href
      )}`,
      backgroundColor: "#25d366",
    },
  ];

  const handleOpcaoChange = (opcao) => {
    setOpcaoSelecionada(opcao);
  };

  const livroSelecionado = {
    id: ebook?.id,
    titulo: ebook?.titulo,
    image: ebook?.image,
    preco: opcaoSelecionada === "fisico" ? precoFisico : precoDigital,
    formato: opcaoSelecionada,
  };

  let item = null;
  // Check if ebook is not null before destructure
  if (ebook !== null) {
    const { titulo, preco, image } = ebook;
    item = { id, titulo, preco, image };
  }
  const main = process.env.REACT_APP_MAIN;
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [isModalPreviewOpen, setModalPreviewOpen] = useState(false);
  const [modalPreviewData, setModalPreviewData] = useState(null);

  const handleCloseModalPreview = () => {
    setModalPreviewOpen(false);
    setModalPreviewData(null);
  };

  const handleOpenModalPreview = () => {
    setModalPreviewOpen(true);
    setModalPreviewData(ebook.previewUrl);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalData(null);
  };

  const [viewCount, setViewCount] = useState(0);

  const toggleAlert = () => {
    alert("Essa função ainda não está pronta!");
  };

  useEffect(() => {
    const generateRandomNumber = () => {
      return Math.floor(Math.random() * (300 - 200 + 1)) + 200;
    };
    setViewCount(generateRandomNumber());
  }, []);

  const formatDateBR = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <div className="livro-container" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 60px" }}>
      {ebook ? (
        <>
          <div className="livro-academico">
            <div className="breadcrumb">
              <Link to={main}>Início</Link>
              <span> / </span>
              <Link to={main + "livros"}>Livros</Link>
              <span> / </span>

              <p className="active">
                <TextoTruncado texto={ebook.titulo} limite={32}></TextoTruncado>
              </p>
            </div>

            <div className="produto-flex pt-3 gap-4 justify-content-between">
              <div className="pag-livro-img">
                <img
                  className="img-produto" style={{ borderRadius: "10px" }}
                  src={`https://insigneacademica.com.br/api/public/${ebook.image}`}
                  alt={ebook.titulo}
                ></img>
              </div>
              <div className="detalhes d-flex flex-column  justify-content-between gap-2" style={{ maxWidth: "550px" }}>


                <div>
                  <h1 style={{ fontSize: "32px" }}>{ebook.titulo}{(ebook.subtitulo !== null && ebook.subtitulo !== "null") && <>: {ebook.subtitulo}</>}</h1>

                  <p className="mb-2" style={{ fontSize: "14px", color: "#FA7F08" }}>
                    <strong>{ebook.autores.length > 1 ? "Autores:" : "Autor:"}</strong>{" "}
                    {ebook.autores.map((autor, index) => (
                      <span key={index}>
                        {autor}
                        {index < ebook.autores.length - 1 ? ", " : "."}
                      </span>
                    ))}
                  </p>

                  <p style={{ fontSize: "16px", color: "#6C6CDF" }}>
                    Esta página foi vista <strong>{ebook.views}</strong>{" "}
                    vezes desde {formatDateBR(ebook.created_at)}.
                  </p>
                  <button className="orange-outline-btn my-3" onClick={handleOpenModalPreview}>
                    Leia um trecho
                  </button>

                  <div>

                    {ebook.categorias.map((categoria, index) => (
                      <span key={index} className="badge" style={{ backgroundColor: "#26265C", color: "#6C6CDF", fontSize: "16px", padding: "8px", borderRadius: "4px", marginRight: "8px" }}>
                        {categoria}

                      </span>
                    ))}
                  </div>


                  {/* <div>
                        <h4>Compartilhe este livro</h4>
                        <div className="d-flex gap-2">
                          {shareLinks.map((link, index) =>
                            link.link ? (
                              <a
                                key={index}
                                href={link.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn text-white border-0"
                                aria-label={`Compartilhar no ${link.platform}`}
                                style={{
                                  backgroundColor: link.backgroundColor,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "10px",
                                }}
                              >
                                <i
                                  className={`bi ${link.iconClass}`}
                                  style={{ fontSize: "16px" }}
                                ></i>
                              </a>
                            ) : null
                          )}
                        </div>
                      </div> */}
                </div>

                <PriceCardToggle ebook={ebook} />

              </div>
            </div>
          </div>

          {/* <div className="d-flex gap-4">
            <div>
              <h3>Conheça os autores</h3>
              <div>
                {ebook.autores.map((autor, index) => (
                  <div key={index}>
                    <p>{autor}</p>
                    
                  </div>
                ))}
              </div>
            </div>
            <div>
              <h3>Informações Sobre o Livro:</h3>
              <div>
                <p>ISBN: {fakeBookData.ISBN}</p>
                <p>Número de Páginas: {fakeBookData.NumeroPaginas}</p>
                <p>Edição: {fakeBookData.Edição}</p>
                <p>Formato: {fakeBookData.Formato}</p>
                <p>Acabamento: {fakeBookData.Acabamento}</p>
                <p>Coloração: {fakeBookData.Coloração}</p>
                <p>Tipo de Papel: {fakeBookData.TipoDePapel}</p>
                <p>Idioma: {fakeBookData.Idioma}</p>
              </div>
            </div>
          </div> */}

            <div className="sinopse-container" style={{ border: "1px solid #FFFFFF26", borderRadius: "8px", padding: "32px", marginBottom: "120px" }}>
              <h3 style={{ fontSize: "24px" }}>SINOPSE:</h3>
              <div className="sinopse" style={{ fontSize: "16px" }}>
                {ebook.sinopse.split(/\r?\n/).map((paragraph, index) => (
                  <p className="mt-2" key={index}>
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>

          <div className="locais-container">
            <h3>Quer adquirir esta obra em outros formatos?</h3>
            <div className="locais-venda">
              {ebook.locais_de_venda.map((local, index) => (
                <li key={index}>
                  <a
                    href={local.url}
                    className="main-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {local.nome}
                  </a>
                </li>
              ))}
            </div>
          </div>

          <div className="livro-bottom">
            <p className="justify">
              InsigneCoins são as moedas digitais da Insigne Acadêmica que podem
              ser utilizadas, a qualquer tempo, para a obtenção de descontos em
              compras posteriores nesta plataforma de e-books.
            </p>
            <p>1 InsigneCoin equivale a R$ 0,25.</p>
          </div>
          </>
          ) : (
          <div className="loading-container">
            <div className="loading-circle"></div>
          </div>
      )}

          {isModalPreviewOpen && (
            <ModalPreview
              pdfUrl={
                "https://insigneacademica.com.br/api/get-pdf-preview?pdf_path=" +
                ebook.pdf
              }
              onClose={handleCloseModalPreview}
            />
          )}

          {isModalOpen && (
            <ModalCarrinho data={modalData} onCloseModal={handleCloseModal} />
          )}
        </div>
      );
};

      export default LivroAcademico;
